/**
 * 延迟函数
 * @param ms 延迟毫秒数
 * @returns Promise
 */
export const delay = (ms: number): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

/**
 * 生成唯一ID
 * @returns 唯一ID字符串
 */
export const generateId = (): string => {
  return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};

/**
 * 手机号码私密展示
 * @param phoneNumber 手机号码
 * @returns 私密展示的手机号码
 */
export const maskPhoneNumber = (phoneNumber: string | number): string => {
  return `${phoneNumber}`.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
};
